import { css } from '@/styled-system/css';

export const borderStyles = css.raw({
  border: '1px solid {colors.border.subtle}',
  flex: 1,
  padding: '400',
});

export const sectionFlexStyles = css.raw({
  display: 'flex',
  flexDirection: { base: 'row', lg: 'column' },
  alignItems: 'flex-start',
  justifyContent: { base: 'flex-start', lg: 'space-between' },
  gap: '200',
});
